<div class="quick-filters">
  <section class="quick-filters__top-row">
    <div>
      <p class="quick-filters__title">{{ 'status' | ppTranslate }}:</p>

      <pp-toggle-button
        [ppIsSelected]="isAllSelectedByKey['status']"
        (ppHandleSelect)="handleSelectAll('status', allStatus)"
        (ppHandleDeselect)="handleDeselectAll('status', allStatus)"
        [attr.data-test]="'statusToggleSelectButton'"
      />

      <div class="quick-filters__status" data-test="quickStatusFilters">
        @for (status of allStatus; track status) {
          <div class="quick-filters__container__item">
            <pp-checkbox
              [ppChecked]="status.selected"
              (ppOnValueChange)="updateStatusValue(status)"
              ppType="solid"
            >
              <pp-status-button
                class="quick-filters__container__item--button"
                [ppStatus]="status.value"
              />
            </pp-checkbox>
          </div>
        }
      </div>
    </div>

    <div class="quick-filters__container">
      <p class="quick-filters__title">{{ 'priority' | ppTranslate }}:</p>

      <pp-toggle-button
        [ppIsSelected]="isAllSelectedByKey['priority']"
        (ppHandleSelect)="handleSelectAll('priority', priorities)"
        (ppHandleDeselect)="handleDeselectAll('priority', priorities)"
        [attr.data-test]="'priorityToggleSelectButton'"
      />

      <div data-test="quickPriorityFilters">
        @for (priority of priorities; track priority) {
          <div class="quick-filters__container__item">
            <pp-checkbox
              [ppChecked]="priority.selected"
              (ppOnValueChange)="togglePriority(priority)"
              class="priorityCheckbox"
              ppType="solid"
              [ppAriaLabel]="priority.label + ' priority toggle'"
              [attr.checked]="priority.selected"
              [attr.data-test]="priority.testId"
            >
              <div class="quick-filters__container__item--button">
                <pp-priority-button [ppPriority]="priority.value" />
              </div>
            </pp-checkbox>
          </div>
        }
      </div>
    </div>
  </section>

  @if (isOverview || isTimeline) {
    <section class="quick-filters__account-sites">
      <p class="quick-filters__title">{{ 'site_accounts' | ppTranslate }}:</p>

      <pp-filter-field-account-sites
        (ppOnValueChange)="applyAccountSitesFilters($event)"
        [ppPreviousSelectedAccounts]="selectedAccountSites"
      />
    </section>
  }

  <section class="quick-filters__tags">
    <pp-filter-tags
      [ppFilters]="tagFilters"
      [ppHasLargeTitle]="true"
      (ppOnValueChange)="applyTagFilters()"
      (ppOnExcludedTagsValueChange)="applyExcludedTagFilters()"
      [attr.data-test]="'quick-filter-tags'"
    />
  </section>

  <section>
    <p class="quick-filters__title">{{ 'created_by' | ppTranslate }}:</p>
    <pp-filter-users
      [attr.data-test]="'createdByInput'"
      ppFilterType="createdBy"
      [ppFilters]="userFilters"
      (ppOnValueChange)="handleApplyCreatedByFilters($event)"
      (ppOnClose)="handleCloseTriggerGA($event, 'CREATED_BY')"
      (ppOnOpen)="handleCreatedByOpen()"
    />
  </section>

  <section>
    <p class="quick-filters__title">{{ 'assigned_to' | ppTranslate }}:</p>
    <pp-filter-users
      [attr.data-test]="'assignedToInput'"
      [ppFilters]="userFilters"
      ppFilterType="assignees"
      (ppOnValueChange)="handleAssignedToChange($event)"
      (ppOnClose)="handleCloseTriggerGA($event, 'ASSIGNEES')"
      (ppOnOpen)="handleAssignedToOpen()"
    />
  </section>
</div>
